import { useDemo } from "../zustand/DemoZustand";
import { Sprechblase, Textmarker } from "./Symbole";
import { nameVon } from "../hilfen/auswertung";
import { kurzesDatum, uhrzeit } from "../hilfen/datum";

/*
  Die Kommentare am Rand.

  Sie stehen rechts neben dem Blatt, in der Reihenfolge des Textes — so, wie
  man es kennt. Ein eigener Reiter, in den man wechseln muss, war der erste
  Versuch und der schlechtere: Wer einen Kommentar liest, will die Stelle
  dazu sehen, nicht danach suchen.

  Am Dokument wird weiterhin NICHT geantwortet. Ein Kommentar ist eine
  Feststellung — „hier fehlt der Stellplatzschlüssel" —, keine
  Gesprächseröffnung. Wer darüber reden will, gibt ihn in den Chat; dafür
  ist der Knopf da. Die Begründung steht in KOMMUNIKATION.md und gilt
  unverändert, auch wenn die Kommentare jetzt anders aussehen.
*/

export default function Randnotizen({
  markierungen,
  aufSpringen,
  aufBearbeiten,
  aufInDenChat,
  /*
    Woran ein Kommentar hing, wenn es die Stelle nicht mehr gibt. Am
    Dokument ist das eine Textstelle, in einer Tabelle eine Zelle — und
    „Die Textstelle dazu gibt es nicht mehr" klingt bei einer gelöschten
    Zeile schief.
  */
  verwaistText = "Die Textstelle dazu gibt es nicht mehr.",
  leerText = "Noch keine Kommentare. Wähl im Text eine Stelle aus — dann kannst du etwas dazu schreiben.",
}) {
  const { stammdaten, ich } = useDemo();

  if (markierungen.length === 0) {
    return (
      <aside className="rand nicht-drucken">
        <p className="klein leise rand__leer">{leerText}</p>
      </aside>
    );
  }

  return (
    <aside className="rand nicht-drucken">
      {markierungen.map((notiz) => {
        const eigen = notiz.verfasserId === ich.id;
        /*
          Die Stelle kann verschwunden sein, wenn jemand den Text gelöscht
          hat, an dem der Kommentar hing. Dann bleibt er stehen und sagt es —
          das ist ehrlicher, als ihn wegzuwerfen oder irgendwohin zu setzen.
        */
        const verwaist = !notiz.stelle;

        return (
          <article key={notiz.id} className={`randnotiz ${verwaist ? "randnotiz--verwaist" : ""}`}>
            <p className="randnotiz__wer">
              {nameVon(stammdaten, notiz.verfasserId, ich.id)} · {kurzesDatum(notiz.zeit)},{" "}
              {uhrzeit(notiz.zeit)}
            </p>

            <blockquote className="randnotiz__zitat">„{notiz.zitat}“</blockquote>
            <p className="randnotiz__text">{notiz.notiz}</p>

            {verwaist && (
              <p className="klein leise">{verwaistText}</p>
            )}

            <div className="randnotiz__fuss">
              {!verwaist && (
                <button className="notiz__knopf" onClick={() => aufSpringen(notiz)}>
                  <Textmarker groesse={14} />
                  Zur Stelle
                </button>
              )}

              {aufInDenChat && (
                <button className="notiz__knopf" onClick={() => aufInDenChat(notiz)}>
                  <Sprechblase groesse={14} />
                  In den Chat
                </button>
              )}

              {eigen && aufBearbeiten && (
                <button className="notiz__knopf" onClick={() => aufBearbeiten(notiz)}>
                  Bearbeiten
                </button>
              )}
            </div>
          </article>
        );
      })}
    </aside>
  );
}
